import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import whitelogo from "../../assets/whitelogo.png";
import { getSocialMedia, type SocialMedia } from '../../lib/site-api';
import { useAuth } from '../../lib/use-auth';

const SOCIAL_ICONS: Record<string, JSX.Element> = {
  facebook: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 12.0611C22 6.53821 17.5229 2.06104 12 2.06104C6.47715 2.06104 2 6.53821 2 12.0611C2 17.0543 5.65683 21.192 10.4375 21.9429V14.9517H7.89844V12.0611H10.4375V9.85947C10.4375 7.35416 11.9305 5.96885 14.2139 5.96885C15.3075 5.96885 16.4512 6.16416 16.4512 6.16416V8.62354H15.1922C13.9512 8.62354 13.5625 9.39366 13.5625 10.1843V12.0611H16.3359L15.8926 14.9517H13.5625V21.9429C18.3432 21.192 22 17.0543 22 12.0611Z" fill="white" />
    </svg>
  ),
  instagram: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.06104C14.717 2.06104 15.039 2.07204 16.108 2.12104C17.175 2.17004 17.903 2.33904 18.54 2.58704C19.199 2.84304 19.756 3.18704 20.312 3.74304C20.868 4.29904 21.211 4.85604 21.468 5.51504C21.716 6.15104 21.885 6.88004 21.934 7.94604C21.982 9.01504 21.994 9.33704 21.994 12.054C21.994 14.771 21.983 15.093 21.934 16.162C21.885 17.229 21.716 17.957 21.468 18.594C21.212 19.253 20.868 19.81 20.312 20.366C19.756 20.922 19.199 21.265 18.54 21.522C17.904 21.77 17.175 21.939 16.109 21.988C15.04 22.037 14.718 22.049 12 22.049C9.282 22.049 8.96 22.038 7.892 21.988C6.825 21.939 6.097 21.77 5.46 21.522C4.801 21.266 4.244 20.922 3.688 20.366C3.132 19.81 2.788 19.253 2.532 18.594C2.284 17.958 2.115 17.229 2.066 16.163C2.018 15.094 2.006 14.772 2.006 12.055C2.006 9.33804 2.017 9.01604 2.066 7.94704C2.115 6.88004 2.284 6.15204 2.532 5.51504C2.788 4.85604 3.132 4.29904 3.688 3.74304C4.244 3.18704 4.801 2.84304 5.46 2.58704C6.096 2.33904 6.825 2.17004 7.891 2.12104C8.96 2.07204 9.282 2.06104 12 2.06104ZM12 7.05404C9.239 7.05404 7 9.29304 7 12.054C7 14.815 9.239 17.054 12 17.054C14.761 17.054 17 14.815 17 12.054C17 9.29304 14.761 7.05404 12 7.05404ZM12 15.054C10.343 15.054 9 13.711 9 12.054C9 10.397 10.343 9.05404 12 9.05404C13.657 9.05404 15 10.397 15 12.054C15 13.711 13.657 15.054 12 15.054ZM18.25 5.80404C18.25 6.35632 17.8023 6.80404 17.25 6.80404C16.6977 6.80404 16.25 6.35632 16.25 5.80404C16.25 5.25175 16.6977 4.80404 17.25 4.80404C17.8023 4.80404 18.25 5.25175 18.25 5.80404Z" fill="white" />
    </svg>
  ),
  linkedin: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3ZM8.5 18H6V10H8.5V18ZM7.25 8.95C6.44919 8.95 5.8 8.30081 5.8 7.5C5.8 6.69919 6.44919 6.05 7.25 6.05C8.05081 6.05 8.7 6.69919 8.7 7.5C8.7 8.30081 8.05081 8.95 7.25 8.95ZM18 18H15.5V13.5C15.5 12.3954 14.6046 11.5 13.5 11.5C12.3954 11.5 11.5 12.3954 11.5 13.5V18H9V10H11.5V11.2C12.1 10.4 13 10 14.2 10C16.3 10 18 11.7 18 13.8V18Z" fill="white" />
    </svg>
  ),
  twitter: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.244 2H21.5l-7.4 8.46L23 22h-6.8l-5.31-6.94L4.8 22H1.54l7.92-9.06L1 2h6.95l4.8 6.34L18.244 2zm-1.2 18h1.84L7.05 4H5.1l11.943 16z"/>
    </svg>
  ),
  youtube: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.016 3.016 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.377-.505a3.016 3.016 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.546 15.568V8.432L15.818 12l-6.272 3.568z"/>
    </svg>
  ),
};

export function Footer() {
  const [social, setSocial] = useState<SocialMedia | null>(null);
  // Logged-in pros shouldn't see customer CTAs ("Book Now", "Become a
  // Pro") or booking-only support links — swap in pro-relevant ones.
  const { isAuthenticated: isPro } = useAuth();

  useEffect(() => {
    getSocialMedia()
      .then((res) => setSocial(res.info))
      .catch(() => setSocial(null));
  }, []);

  // LinkedIn is intentionally omitted — we promote only Instagram +
  // Facebook in the footer. The IG/FB URLs fall back to the official
  // accounts so they always render even before an admin sets them in
  // Social Media settings (an admin-set value still takes precedence).
  const socialLinks = [
    {
      key: 'facebook',
      url:
        social?.facebook_url ||
        'https://www.facebook.com/profile.php?id=61588208559411',
    },
    {
      key: 'instagram',
      url:
        social?.instagram_url ||
        'https://www.instagram.com/cherrypickedservices/',
    },
    { key: 'twitter', url: social?.twitter_url },
    { key: 'youtube', url: social?.youtube_url },
  ].filter((l): l is { key: string; url: string } => !!l.url);

  const quickLinks = isPro
    ? [
        { label: 'Dashboard', to: '/professional/dashboard' },
        { label: 'About Us', to: '/about-us' },
        { label: 'Help Center', to: '/professional/help-center' },
      ]
    : [
        { label: 'Become a Pro', to: '/professional/signup' },
        { label: 'About Us', to: '/about-us' },
        { label: 'Book Now', to: '/booking-location' },
        { label: 'Help Center', to: '/help-center' },
      ];

  const supportHeading = isPro ? 'Support' : 'Bookings support';
  const supportLinks = isPro
    ? [
        { label: 'Help Center', to: '/professional/help-center' },
        { label: 'Customer Support', to: '/contact-us' },
        { label: 'Terms & Conditions', to: '/terms-of-use' },
      ]
    : [
        { label: 'Help Center', to: '/help-center' },
        { label: 'Cancellation', to: '/cancellation-policy' },
        { label: 'Customer Support', to: '/contact-us' },
        { label: 'Terms & Conditions', to: '/terms-of-use' },
      ];

  return (
    <>
      <footer className="bg-[#8e2a2f] py-16 text-white mt-auto">
        <div className="max-w-[1140px] mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-0">
            {/* Brand Section */}
            <div className="lg:col-span-6">
              <div className="w-[120px] mb-6">
                <img src={whitelogo} alt="Cherry Picked" className="w-full object-contain" />
              </div>
              <p className="font-['DM_Sans',sans-serif] text-[#eee] text-[14px] leading-[21px] tracking-[-0.1px] max-w-[420px]">
                Carefully selected, seamlessly delivered.
              </p>
              {/* Social Icons */}
              {socialLinks.length > 0 && (
                <div className="flex gap-4 mt-8">
                  {socialLinks.map((l) => (
                    <a
                      key={l.key}
                      href={l.url}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={l.key}
                      className="w-6 h-6 flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity"
                    >
                      {SOCIAL_ICONS[l.key]}
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-3">
              <h4 className="font-['DM_Sans',sans-serif] font-bold text-[#eee] text-[14px] mb-6 tracking-[-0.1px]">Quick Links</h4>
              <ul className="space-y-4 font-['Inter',sans-serif] text-[14px]">
                {quickLinks.map((l) => (
                  <li key={l.label}><Link to={l.to} className="text-white/80 hover:text-white hover:underline transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>

            {/* Support Links */}
            <div className="lg:col-span-3">
              <h4 className="font-['DM_Sans',sans-serif] font-bold text-[#eee] text-[14px] mb-6 tracking-[-0.1px]">{supportHeading}</h4>
              <ul className="space-y-4 font-['Inter',sans-serif] text-[14px]">
                {supportLinks.map((l) => (
                  <li key={l.label}><Link to={l.to} className="text-white/80 hover:text-white hover:underline transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Sub Footer */}
      <div className="bg-white border-t border-[#ede8e9] py-6">
        <div className="max-w-[1140px] mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-6">
            <p className="font-['DM_Sans',sans-serif] text-[#908e8e] text-[14px]">© {new Date().getFullYear()} All rights reserved</p>
            <Link to="/privacy-policy" className="font-['DM_Sans',sans-serif] font-bold text-[#3a3335] text-[14px] hover:text-[#8e2a2f] transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-use" className="font-['DM_Sans',sans-serif] font-bold text-[#3a3335] text-[14px] hover:text-[#8e2a2f] transition-colors">Term of Use</Link>
          </div>

          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2 cursor-pointer group">
              <span className="material-icons text-[#908e8e] text-[18px] group-hover:text-[#8e2a2f] transition-colors">language</span>
              <span className="font-['DM_Sans',sans-serif] font-bold text-[#3a3335] text-[14px] group-hover:text-[#8e2a2f] transition-colors">English</span>
            </div>
            <div className="flex items-center gap-2 cursor-pointer group">
              <span className="material-icons text-[#908e8e] text-[18px] group-hover:text-[#8e2a2f] transition-colors">more_horiz</span>
              <span className="font-['DM_Sans',sans-serif] font-bold text-[#3a3335] text-[14px] group-hover:text-[#8e2a2f] transition-colors">GBP</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
